import React from "react";
import PropTypes from "prop-types";
import { Row } from "react-flexbox-grid/lib/index";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  LinearProgress
} from "@material-ui/core";
import Undo from "@material-ui/icons/Restore";
import CastsInFileTable from "./CastsInFileTable";

const CastsInFileCard = props => (
  <Card>
    <CardHeader title="Click the icon to select a file to recall" />
    <CardContent>
      <Row style={{ marginTop: "1rem" }}>
        {props.soloCastsFetching ? (
          <LinearProgress style={{ marginBottom: 10 }} />
        ) : (
          <CastsInFileTable {...props} />
        )}
      </Row>
    </CardContent>
    <CardActions>
      <Button
        variant="contained"
        color="primary"
        disabled={
          props.soloCastsFetching ||
          props.soloRecallingFiles ||
          props.soloFilesToRecall.length === 0
        }
        onClick={props.onRecallFilesClick}
        style={{ marginLeft: "auto" }}
      >
        Recall files
        <Undo />
      </Button>
    </CardActions>
  </Card>
);

CastsInFileCard.propTypes = {
  soloCastsFetching: PropTypes.bool.isRequired,
  soloRecallingFiles: PropTypes.bool.isRequired,
  onRecallFilesClick: PropTypes.func.isRequired,
  soloFilesToRecall: PropTypes.arrayOf(PropTypes.number).isRequired
};

CastsInFileCard.defaultProps = {};

export default CastsInFileCard;
